// Base
import type { Blueprint } from '@builder/base/blueprints/Blueprint';
import type { AggregateBlueprint } from '@builder/base/blueprints/AggregateBlueprint';
import { instanceOfAggregateBlueprint } from '@builder/base/blueprints/AggregateBlueprint';
import type { ValidationErrors } from '@builder/base/types/ValidationErrors';
import type { ValidatableBlueprint } from '@builder/base/blueprints/ValidatableBlueprint';
import { validateBlueprints } from '@builder/base/blueprints/ValidatableBlueprint';

// Blueprints
import type { BlueprintDefinition } from '@builder/form/blueprints/BlueprintDefinition';
import type { RowBlueprint } from '@builder/form/blueprints/RowBlueprint';

// --------------------------------------------------

export const Definition: BlueprintDefinition = {
    type: 'row',
    name: '[[[Wiersz]]]',
    group: 'none'
};

export interface RowContract extends RowBlueprint, AggregateBlueprint
{
}

export class RowType implements RowContract, ValidatableBlueprint
{
    public kind: 'row' = 'row' as const;
    public id: string;
    public type: string;
    public name: string;
    public components: Blueprint[] = [];
    public errors: ValidationErrors;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.components = [];
        this.errors = {};
    }

    public validate(): Record<string, ValidationErrors>
    {
        this.errors = {};

        return validateBlueprints(this.components);
    }
}

export const instanceOfRowType = (object: any): object is RowType =>
{
    return instanceOfAggregateBlueprint(object) && 'type' in object && object.type === Definition.type;
};
